import React, { useState } from "react";
import { Form } from "reactstrap";
import { v4 } from "uuid";
import UserSettings from "../../components/UserSettings/UserSettings";
import GeneralFormInput from "../../components/GeneralForm/GeneralFormInput";
import CheckoutFormInput from "../../components/GeneralForm/CheckoutFormInput";

import "../../styles/general/_form.scss";
import UserSettingsTitle from "../../components/UserSettings/UserSettingsTitle/UserSettingsTitle";
import { localUser } from "../../assets/Helpers";
import ResetPasswordButton from "./ResetPasswordButton/ResetPasswordButton";
import { useQuery } from "@apollo/react-hooks";
import { GET_CURRENT_USER } from "../../queries/ordersQuery";

const Profile = () => {
  const userInfo = localUser();
  const [profileData, setProfileData] = useState({
    id: "",
    firstName: "",
    lastName: "",
    password: "",
    email: "",
    passwordConfirm: "",
    isUpdated: false,
    updateProfile: false,
    updatePassword: false,
    profileValidateLabel: "",
    passwordValidateLabel: "",
  });

  const { data: userData } = useQuery(GET_CURRENT_USER);

  const dataProfile = userData?.customer ? { user: userData.customer } : null;
  const [mutationLoading, setMutationLoading] = useState(false);

  const handleProfileSubmit = async (e) => {
    e.preventDefault();

    const { firstName, lastName } = profileData;
    setMutationLoading(true);
    
    try {
      // Update profile via API (you may need to add this endpoint)
      // For now, we'll just show success message
      // await api.updateProfile({ firstName, lastName });
      
      if (profileData.updateProfile) {
        setTimeout(() => {
          handleProfileDataChange(
            "profileValidateLabel",
            "Profili u përditusa me sukses!"
          );
        }, 1000);

        handleProfileDataChange("updateProfile", false);

        setTimeout(() => {
          handleProfileDataChange("passwordValidateLabel", "");
        }, 2000);
      }
    } catch (error) {
      console.error("Error updating profile:", error);
    } finally {
      setMutationLoading(false);
    }
  };

  if (!profileData.isLoading && dataProfile) {
    setProfileData({
      ...profileData,
      id: dataProfile.user.id,
      firstName: dataProfile.user.firstName,
      lastName: dataProfile.user.lastName,
      email: dataProfile.user.email,
      isLoading: true,
    });
  }

  const handleProfileChange = (e) => {
    e.target.className = "form-control";
    const { name, value } = e.target;
    setProfileData({
      ...profileData,
      [name]: value,
    });
  };

  const handleProfileDataChange = (name, value) => {
    setProfileData({
      ...profileData,
      [name]: value,
    });
  };

  const handleOnBlur = (e) => {
    if (e.target.value + "" === "") {
      e.target.className = "form-control error";
    }
    if (e.target.name === "password" || e.target.name === "passwordConfirm") {
      handleProfileDataChange("updatePassword", true);
    } else {
      handleProfileDataChange("updateProfile", true);
    }
  };

  return (
    <div className="Profile">
      <UserSettings>
        <UserSettingsTitle title="Llogaria ime" />
        <Form
          className="leftSideForm"
          onSubmit={(e) => {
            handleProfileSubmit(e);
          }}
        >
          <h5>Përditëso të dhënat</h5>
          <CheckoutFormInput
            name="firstName"
            required
            id="firstName"
            type="text"
            placeholder="Emri"
            onChange={(e) => handleProfileChange(e)}
            value={profileData.firstName || ""}
            onBlur={(e) => handleOnBlur(e)}
          />
          <CheckoutFormInput
            name="lastName"
            required
            id="lastName"
            type="text"
            placeholder="Mbiemri"
            onChange={(e) => handleProfileChange(e)}
            value={profileData.lastName || ""}
            onBlur={(e) => handleOnBlur(e)}
          />
          <GeneralFormInput
            name="email"
            type="email"
            disabled={true}
            placeholder="Email"
            value={profileData.email || ""}
          />
          <div
            className={
              "GeneralForm__input" +
              (!profileData.updateProfile
                ? " GeneralForm__input--disabled"
                : "")
            }
          >
            <input
              value="Përditëso të dhënat"
              type="submit"
              disabled={!profileData.updateProfile}
            />
            <p>{profileData.profileValidateLabel}</p>
          </div>
        </Form>
        <ResetPasswordButton userEmail={profileData.email} />
      </UserSettings>
    </div>
  );
};

export default Profile;
